/**
 * Host for the legacy arrangement canvas.
 * Phase 3 keeps pixel-perfect timeline rendering in studio-daw-pro.js
 * while React owns chrome/session controls.
 */
export function ArrangementHost() {
  return (
    <div className="flex h-full min-h-[160px] flex-col">
      <div className="border-b border-daw-border px-3 py-1 text-[10px] uppercase tracking-wide text-daw-muted">
        Arrangement (legacy engine host)
      </div>
      <div
        id="sdproLegacyArrangeHost"
        className="min-h-0 flex-1 bg-daw-bg"
        data-host="arrangement"
      />
    </div>
  );
}
